import { getRequest, postRequest, putRequest } from "./api.request";

const MEDICINE_TRACKING_PATH = "/medicine-tracking/v1";

export const getMedicineRequestsApi = async (params) => {
  try {
    const result = await getRequest(
      `${MEDICINE_TRACKING_PATH}/medicine-requests/${params?.patientId}/${params?.visitId}`,
      { listFor: params?.listFor }
    );
    return result;
  } catch (error) {
    console.error("Error fetching medicine requests:", error);
    throw error;
  }
};

export const getPharmacyRequestApi = async (params) => {
  try {
    return await getRequest(
      `${MEDICINE_TRACKING_PATH}/pharmacy-medicine-requests`,
      {
        ...params,
        _t: Date.now()
      }
    );
  } catch (error) {
    console.error("Error fetching pharmacy requests:", error);
    throw error;
  }
};

export const getPharmacyRequestByIdApi = async (params) => {
  try {
    return await getRequest(
      `${MEDICINE_TRACKING_PATH}/pharmacy-requests/${params?.trackingId}`
    );
  } catch (error) {
    console.error("Error fetching pharmacy request by ID:", error);
    throw error;
  }
};

export const getPharmacyReturnByIdApi = async (params) => {
  try {
    return await getRequest(
      `${MEDICINE_TRACKING_PATH}/pharmacy-returns/${params?.trackingId}`
    );
  } catch (error) {
    console.error("Error fetching pharmacy return by ID:", error);
    throw error;
  }
};

export const addPharmacyRequestAcceptByIdApi = async (id, body) => {
  try {
    return await postRequest(
      `${MEDICINE_TRACKING_PATH}/pharmacy-requests/${id}/accept`,
      body
    );
  } catch (error) {
    console.error("Error accepting pharmacy request:", error);
    throw error;
  }
};

export const addPharmacyRequestRejectByIdApi = async (id, body) => {
  try {
    return await postRequest(
      `${MEDICINE_TRACKING_PATH}/pharmacy-requests/${id}/reject`,
      body
    );
  } catch (error) {
    console.error("Error rejecting pharmacy request:", error);
    throw error;
  }
};

export const addPharmacyRequestDeliverByIdApi = async (id) => {
  try {
    return await postRequest(
      `${MEDICINE_TRACKING_PATH}/pharmacy-requests/${id}/deliver`,
      {}
    );
  } catch (error) {
    console.error("Error delivering pharmacy request:", error);
    throw error;
  }
};

export const getAllMedicineTrackingsApi = async (params) => {
  try {
    return await getRequest(`${MEDICINE_TRACKING_PATH}/all-medicine-trackings`, params);
  } catch (error) {
    console.error("Error fetching all medicine trackings:", error);
    throw error;
  }
};

export const addMedicineRequestApi = async (body) => {
  try {
    const response = await postRequest(`${MEDICINE_TRACKING_PATH}/medicine-request`, body);
    return response;
  } catch (error) {
    console.error("Error adding medicine request:", error);
    throw error;
  }
};

export const addMedicineReturnApi = async (body) => {
  try {
    return await postRequest(`${MEDICINE_TRACKING_PATH}/medicine-return`, body);
  } catch (error) {
    console.error("Error adding medicine return:", error);
    throw error;
  }
};

export const addPharmacyReturnByIdApi = async (id, body) => {
  try {
    return await postRequest(
      `${MEDICINE_TRACKING_PATH}/pharmacy-returns/${id}/approve`,
      body
    );
  } catch (error) {
    console.error("Error adding pharmacy return:", error);
    throw error;
  }
};

export const rejectPharmacyReturnByIdApi = async (id, body) => {
  try {
    return await postRequest(
      `${MEDICINE_TRACKING_PATH}/pharmacy-returns/${id}/reject`,
      body
    );
  } catch (error) {
    console.error("Error rejecting pharmacy return:", error);
    throw error;
  }
};

export const addPharmacyOrderApi = async (body) => {
  try {
    return await postRequest(`${MEDICINE_TRACKING_PATH}/pharmacy-order`, body);
  } catch (error) {
    console.error("Error adding pharmacy order:", error);
    throw error;
  }
};

export const updateMedicineRequestStatusApi = async (params) => {
  try {
    const { trackingId, medicineId, status } = params;
    
    if (!trackingId || !medicineId || !status) {
      throw new Error("Missing required parameters: trackingId, medicineId, status");
    }

    const response = await putRequest(`${MEDICINE_TRACKING_PATH}/update-status`, {
      trackingId,
      medicineId,
      status
    });
    return response;
  } catch (error) {
    console.error("Error updating medicine request status:", error);
    throw error;
  }
};

export const updatePharmacyIssuedQuantitiesApi = async (trackingId, body) => {
  try {
    return await putRequest(
      `${MEDICINE_TRACKING_PATH}/pharmacy-requests/${trackingId}/update-quantities`,
      body
    );
  } catch (error) {
    console.error("Error saving issued quantities:", error);
    throw error;
  }
};
